import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Pane } from '../pane';
import { SliderComponent } from '../slider/slider.component';
import { ViewStrategy } from '../view-strategies/view-strategy';
import { ViewComponent } from '../view/view.component';

@Component({
  selector: 'skm-grid',
  template: `<div class="skm-datepicker-grid" (click)="parentView.selectItem($event, pane, slider.notPanning)">
  <div class="skm-datepicker-indent" [style.width.%]="100 / 7 * pane.indent"></div>
  <div *ngFor="let value of pane.values; trackBy: trackIndex; let i = index" class="skm-datepicker-cell">
    <button type="button" [attr.data-index]="i" [class]="makeItemClasses(i, pane)" [disabled]="isDisabled(i, pane)">
      {{itemLabels[i] || (value | date:itemFormat)}}
    </button>
  </div>
</div>
`,
  styles: [`button{display:block;color:inherit}button:not([disabled]){cursor:pointer}button[disabled]{pointer-events:none}.skm-datepicker-pane{flex-shrink:0;width:100%;display:flex;flex-direction:column;overflow:hidden}.skm-datepicker-week{display:flex}.skm-datepicker-weekday{width:14.28571%}.skm-datepicker-content{flex:1 0 0;display:flex;flex-direction:column}.skm-datepicker-grid{flex:1 0 0;display:flex;flex-wrap:wrap;align-content:flex-start;pointer-events:none}.skm-datepicker-indent{height:16.66667%}.skm-datepicker-cell{display:flex}:host-context(.skm-datepicker-days-view) .skm-datepicker-cell{width:14.28571%;height:16.66667%}:host-context(.skm-datepicker-months-view) .skm-datepicker-cell{width:33.33333%;height:25%}:host-context(.skm-datepicker-years-view) .skm-datepicker-cell{width:20%;height:25%}.skm-datepicker-item{flex:1;pointer-events:auto}`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridComponent implements OnChanges {
  @Input() pane: Pane;

  @Input() currentTimestamp: number;
  @Input() selectedTimestamp: number;
  @Input() minTimestamp: number;
  @Input() maxTimestamp: number;

  @Input() itemFormat: string;
  @Input() itemLabels: string[] = [];

  @HostBinding('class') readonly _hostClass = 'skm-datepicker-content';

  constructor(readonly slider: SliderComponent,
              readonly parentView: ViewComponent,
              private readonly viewStrategy: ViewStrategy) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('itemLabels' in changes) {
      this.itemLabels = this.itemLabels || [];
    }
  }

  makeItemClasses(index: number, pane: Pane): string {
    return [
      this.viewStrategy.itemClass,
      'skm-datepicker-item',
      (pane.values[index] === this.currentTimestamp) ? 'skm-datepicker-current' : '',
      (pane.values[index] === this.selectedTimestamp) ? 'skm-datepicker-selected' : '',
    ].join(' ');
  }

  isDisabled(index: number, pane: Pane): boolean {
    return (pane.values[index] < this.minTimestamp) || (pane.values[index] > this.maxTimestamp);
  }

  trackIndex(index: number): number {
    return index;
  }

}
